export default {
  theme: {
    light: "Light",
    dark: "Dark",
    switchToLight: "Switch to light theme",
    switchToDark: "Switch to dark theme",
  },
  routes: {
    title: "Routes",
    viewList: "As a list",
    viewMap: "On the map",
    count: "Routes: {n}",
    empty: "Nothing matches the filters",
    reset: "Reset filters",
    gradeFilter: "Difficulty filter",
    durationFilter: "Duration",
    shape: { label: "Shape", loop: "Loop", linear: "One way" },
    source: { label: "Source", all: "All", curated: "EcoWay", community: "From users", communityBadge: "By a user · not checked by EcoWay", verified: "Verified by EcoWay", unverified: "Community route, not verified by EcoWay", author: "Author", unverifiedShort: "not verified by EcoWay" },
    distanceLabel: "Distance:",
    distanceFromYou: "from you",
  },
  safety: {
    nearestShelters: "Nearest shelters",
    nearestSheltersHint: "MChS rescue huts nearest to you first.",
    sheltersQuery: "Rescue huts",
    title: "Safety",
    loggedOutTitle: "Sign in to register hikes",
    loggedOutBody: "Registering a hike tells your contacts and rescuers where you went and when to expect you back.",
    noTrip: "No active hike",
    registerCta: "Register a hike",
    returnBy: "return by",
    timeLeft: "Time left",
    overdue: "Return time has passed",
    overdueFor: "Overdue by",
    daysShort: "d",
    history: "Hike history",
    call112: "Call 112",
  },
  filters: {
    label: "Quick filters",
    short: "Half day",
    day: "Full day",
    multi: "Multi-day",
    easy: "Easy T1–T2",
  },
  ui: {
    gradeAria: "Difficulty T{n}",
  },
  common: {
    previous: "Previous",
    next: "Next",
    close: "Close",
    comingSoon: "This feature is still in development",
    loading: "Loading…",
    dismissLabel: "Clear",
  },

  news: {
    title: "What's new",
    backToApp: "Back to the app",
    backToArchive: "All updates",
    empty: "No updates yet",
    loadError: "Failed to load",
    showMore: "Show more",
    notFoundTitle: "Document not found",
    notFoundBody: "The link may be outdated.",
    accept: "Accept",
    accepted: "Accepted",
    acceptError: "Could not accept, please try again",
    loginToAccept: "Sign in to accept this document",
    outdated: "This is an outdated version of the document.",
    openLatest: "Open the current version",
  },
  notifications: {
    filterAll: "All",
    filterUnread: "Unread",
    emptyUnread: "No unread notifications",
    unreadDot: "You have unread notifications",
    caption: "Updates about your routes and service news",
    markAllRead: "Mark all as read",
    showMore: "Show more",
    emptyTitle: "Nothing new yet",
    emptyBody: "Reviews, return reminders and EcoWay news will show up here.",
    loading: "Loading...",
    accept: "Accept",
    unknown: "Notification",
    kinds: {
      review_received: { title: "New review on your route", body: "\"{route_name}\": {stars} out of 5" },
      registration_soon: { title: "Return time is coming up", body: "\"{route_name}\": be back by {expected_return_at}" },
      registration_overdue: { title: "Return time has passed", body: "\"{route_name}\": expected by {expected_return_at}. Please mark your return" },
      hello_published: { title: "Your hello is published" },
      feedback_new: { title: "New feedback report" },
      hello_request_new: { title: "New hello request", body: "From: {submitter_name}" },
      security_digest: { title: "Security events in the last hour: {count}" },
      glitchtip_digest: { title: "New errors in the last hour: {count}" },
    },
  },
  app: {
    skipToContent: "Skip to content",
    navLabel: "Main navigation",
    profileButton: { guest: "Sign in and open profile", user: "My profile" },
    tabs: { safety: "Safety", me: "Me", map: "Routes", live: "Live", explore: "Explore", profile: "Profile", admin: "Admin" },
    feedbackButton: "Feedback",
    sidebar: { show: "Show panel", hide: "Hide panel" },
    mapLoading: "Loading map…",
    footer: { copyright: "© {year} EcoWay · project operator: ORTRA LLP · Kazakhstan" },
    install: {
      title: "Install EcoWay",
      subtitle: "Quick access from your home screen, like an app",
      installButton: "Install",
      dismissLabel: "Dismiss",
      iosInstructions: "Tap Share at the bottom of Safari, then \"Add to Home Screen\"",
    },
    cookieConsent: {
      title: "We use cookies",
      message: "Essential cookies are required to log in and view camera video. With your consent, we also use analytics to understand how to improve EcoWay. You can change your choice anytime in Profile → Settings.",
      acceptAll: "Accept all",
      essentialOnly: "Essential only",
      customize: "Customize",
      customizeTitle: "Cookie settings",
      alwaysOn: "Always on",
      essential: {
        title: "Essential",
        description: "Account login, camera video-viewing session. The site won't work without these.",
      },
      analytics: {
        title: "Analytics",
        description: "Google Analytics — helps us understand which parts of the site are used most.",
      },
      save: "Save choice",
      back: "Back",
      dismissLabel: "Close",
    },
  },

  leftPanel: {
    brand: "EcoWay",
    searchPlaceholder: "Search places, routes, points",
    sortLabel: "Sort",
    sort: {
      recommended: "Recommended",
      distance: "By distance",
      elevation: "By elevation gain",
      name: "By name",
      nearest: "Nearest to me",
      duration: "By duration",
    },
  },

  search: {
    cancel: "Cancel",
    recent: "Recent searches",
    showMore: "Show more",
    clearHistory: "Clear",
    groupPlaces: "Places",
    groupRoutes: "Routes",
    groupPoints: "Points",
    more: "{n} more",
    noResults: "Nothing found",
    loading: "Searching…",
    originUser: "from you",
    originCenter: "from centre",
    originToCenter: "Measure from map centre",
    originToUser: "Measure from your position",
    nearTo: "near {name} · {distance}",
    nearbyRoutes: "Routes nearby",
    example1: "Butakovsky Waterfall",
    example2: "Titov Pass",
    example3: "Water",
    example4: "Routes to lakes",
    recentTitle: "Recent",
    noResultsHint: "Try another name or check the spelling",
    error: "Search failed",
    retry: "Retry",
    allRoutes: "All routes",
    routeSubtitle: "Route · {km} km",
    loadingRoutes: "Loading routes…",
    routesError: "Couldn't load routes",
    elevation: "{m} m",
    kinds: { peak: "peak", volcano: "volcano", hill: "hill", ridge: "ridge", mountain_pass: "pass", saddle: "saddle", spring: "spring", drinking_water: "drinking water", water_point: "water point", water_tap: "water tap", water_well: "well", waterfall: "waterfall", shelter: "shelter", alpine_hut: "alpine hut", wilderness_hut: "wilderness hut", camp_site: "campsite", mountain_rescue: "rescue post", rescue_hut: "rescue hut", viewpoint: "viewpoint", parking: "parking", danger: "danger", lake: "lake", water: "water", glacier: "glacier", village: "village", town: "town", city: "city", hamlet: "hamlet", locality: "locality", firepit: "fire pit", picnic_table: "picnic table", toilets: "toilets", cave_entrance: "cave entrance", rock: "rock", tower: "tower", cable_car_station: "cable car station", ford: "ford", grassland: "meadow", wetland: "wetland", suburb: "suburb", neighbourhood: "neighbourhood", valley: "valley", gorge: "gorge", region: "region" },
  },

  point: {
    back: "Back",
    close: "Close the card",
    loading: "Loading the point…",
    notFound: "Point not found",
    notFoundHint: "It may have been hidden or removed. Go back.",
    error: "Could not load the point",
    nearbyPoints: "Points nearby",
  },

  poiTypes: {
    start: "Start",
    finish: "Finish",
    "night-stop": "Night stop",
    "via-point": "Via point",
    water: "Water",
    danger: "Danger",
    viewpoint: "Viewpoint",
    note: "Note",
    "rest-stop": "Rest stop",
    junction: "Junction",
    shelter: "Shelter",
    parking: "Parking",
  },

  routeStatus: {
    active: "Open",
    draft: "Moderate",
    closed: "Closed",
    unknown: "—",
  },

  units: {
    km: "km",
    m: "m",
    decimal: ".",
    h: "h",
    min: "min",
    ms: "m/s",
    hpa: "hPa",
    mm: "mm",
    mmhr: "mm/h",
    wm2: "W/m²",
  },

  reviews: {
    noRatings: "No ratings yet",
    dialogTitle: "Your review",
    yourRating: "Your rating",
    commentLabel: "Comment (optional)",
    commentPlaceholder: "How was the trail, water, weather?",
    submit: "Submit",
    delete: "Delete review",
    error: "Could not save the review. Please try again.",
    count: "{n} ratings",
    showMore: "Show more",
    ctaTitle: "Hiked this route?",
    mineTitle: "Your review",
    showAll: "Show all reviews ({n})",
    ctaText: "Share how the trail, water and weather were.",
    mineText: "You have already rated this route.",
    cta: "Leave a review",
    edit: "Edit review",
  },
  routeDetails: {
    actionsLabel: "Route actions",
    conditionsNow: "Now: {name}, {km} km",
    plate: { loss: "Descent", distance: "Distance", gain: "Gain", max: "Elevation", time: "Time" },
    back: "Back",
    close: "Close the card",
    eyebrow: "Route",
    description: "Description",
    descriptionMore: "Read more",
    descriptionLess: "Show less",
    weatherShort: "Weather",
    shareMenu: { link: "Share link" },
    gettingThere: { title: "Getting to the start", copy: "Copy coordinates", copied: "Coordinates copied", open2gis: "Open in 2GIS", openGoogleMaps: "Open in Google Maps" },
    maxElevation: "max",
    stats: {
      distanceHint: "Route distance",
      gainHint: "Elevation gain",
      lossHint: "Elevation loss",
      maxElevationHint: "Highest point on the route",
    },
    timeInTransit: "Time in transit — coming soon",
    estimatedTimeDisclaimer: "Estimated hiking time, rounded up to the nearest half hour (based on the track's distance and slope, Tobler's hiking function). Doesn't account for personal fitness, pack weight, or weather conditions — actual time may vary noticeably.",
    like: "Like",
    format: {
      label: "Format",
      loop: "Loop",
      linear: "Point-to-point",
      halfDay: "Half day",
      fullDay: "Full day",
      returnNote: "Return via the same path",
    },
    actions: {
      registerFull: "Register",
      save: "Save",
      saved: "Saved",
      saveLoginRequired: "Log in to save routes",
      likeLoginRequired: "Sign in to like",
      share: "Share",
      register: "Register",
      download: "Download",
    },
    elevationProfile: "Elevation profile",
    elevationProfileAria: "Route elevation profile",
    elevationProfileCursorAria: "Route elevation profile — click or drag to place a point on the route",
    days: "Days on the route",
    dayWord: { one: "day", few: "days", many: "days" },
    weather: {
      title: "Weather near the route",
      loading: "Loading forecast…",
      windUpTo: "Wind up to",
      forecastSource: "Forecast · open-meteo.com",
      unavailable: "Weather forecast isn't available for this area",
      infoTitle: "Where does this weather come from?",
      infoText: "This forecast is averaged across the whole route rather than tied to one exact spot. On long routes, conditions at different sections and elevations can differ noticeably from what's shown.",
    },
    risks: {
      title: "Seasonal risks",
      text: "Shaded sections may have ice in the morning; expect mud and slippery rocks after rain.",
    },
    feedbackCta: {
      text: "Noticed something off, or know how this route could be improved? Send us a note — we'll check it and make useful changes.",
      button: "Send feedback",
    },
    tabs: {
      label: "Card sections",
      days: "Days",
      overview: "Overview",
      reviews: "Reviews",
      photos: "Photos",
      soon: "soon",
    },
    gpxModal: {
      disclaimer: "The route and track are for navigation reference only. Real conditions on the ground may differ — rely on actual terrain, markers, and conditions.",
      downloadButton: "Download GPX",
    },
    selectRoute: "Select a route",
    toast: {
      saved: "Added to saved",
      linkCopied: "Link copied",
    },
    grade: {
      1: "Easy",
      2: "Simple",
      3: "Moderate",
      4: "Hard",
      5: "Very hard",
      6: "Extreme",
    },
    weatherCode: {
      "0": "Clear",
      "1": "Mostly clear",
      "2": "Partly cloudy",
      "3": "Cloudy",
      "45": "Fog",
      "48": "Rime fog",
      "51": "Light rain",
      "53": "Light rain",
      "55": "Heavy drizzle",
      "61": "Rain",
      "63": "Rain",
      "65": "Heavy rain",
      "66": "Freezing rain",
      "67": "Freezing rain",
      "71": "Snow",
      "73": "Snow",
      "75": "Heavy snow",
      "77": "Snow grains",
      "80": "Showers",
      "81": "Showers",
      "82": "Heavy showers",
      "85": "Snow showers",
      "86": "Heavy snow showers",
      "95": "Thunderstorm",
      "96": "Thunderstorm with hail",
      "99": "Thunderstorm with hail",
    },
    advisory: {
      snow: "Snow is possible — bring a warm layer and be ready for slippery sections at altitude.",
      rain: "Rain is possible — the trail may be slippery, expect mud after precipitation.",
      storm: "Thunderstorm risk — avoid open ridges and summits.",
      fog: "Fog is possible — visibility on the route may be limited.",
      none: "No significant weather risks expected.",
    },
    day: { today: "Today", tomorrow: "Tomorrow" },
  },

  gradeModal: {
    title: "What does difficulty mean?",
    close: "Close",
    subtitle: "Scale from T1 (easy) to T6 (extreme)",
    thisRoute: "this route",
    footer: "The T1–T6 scale describes technical difficulty. It doesn't replace weather, seasonal, or fitness assessments.",
    descriptions: {
      1: "A simple walk on a good trail or road. Suitable for beginners and easy strolls.",
      2: "An easy mountain route on a clear trail. Expect some climbing, rocks, or uneven ground.",
      3: "A demanding mountain route. Requires confident hiking, decent fitness, and attention to weather.",
      4: "An alpine hiking route. Expect steep sections, scree, snow, poor trail, and the need for confident navigation.",
      5: "A hard alpine route with difficult terrain, exposure, and sections without a clear trail. Solid experience required.",
      6: "A very hard alpine hiking route, often trail-less, with pronounced exposure and difficult terrain. Requires excellent experience, navigation, and fitness.",
    },
  },

  login: {
    title: "Sign in to EcoWay",
    subtitle: "Track routes and get notifications",
    email: "Email or phone",
    password: "Password",
    passwordPlaceholder: "Enter your password",
    confirmPassword: "Confirm password",
    passwordMismatch: "Passwords don't match",
    passwordHint: "At least 8 characters",
    showPassword: "Show password",
    hidePassword: "Hide password",
    cancel: "Cancel",
    submitLoading: "Signing in…",
    submit: "Sign in",
    errorInvalid: "Invalid email/phone or password",
    errorGeneric: "Couldn't sign in. Please try again later.",
    orDivider: "or",
    emailToggle: "Sign in with email",
    loginWithCode: "Sign in with a code",
    loginWithPassword: "Sign in with a password",
    changeNumber: "Change number",
    sendCode: "Send code",
    sendCodeLoading: "Sending…",
    verifyCode: "Confirm",
    verifyCodeLoading: "Checking…",
    otpCodeLabel: "WhatsApp code",
    otpInvalid: "Incorrect or expired code",
    otpRateLimited: "Too many attempts. Please try again later.",
    invalidPhone: "Enter a valid phone number",
    optionalEmailLabel: "Email (optional)",
    optionalEmailHint: "You'll also be able to sign in with email using the same password",
    phoneOtpStepTitle: "Enter the WhatsApp code",
    phoneOtpStepSubtitle: "We sent a code to {phone}",
    phonePasswordStepTitle: "Create a password",
    phonePasswordStepSubtitle: "Phone confirmed — now set a password to sign in",
    telegramWeb: "Sign in with Telegram Web",
    telegramApp: "Sign in with the Telegram app",
    telegramWaiting: "Open Telegram and tap Start",
    telegramWaitingHint: "This page will update automatically once confirmed",
    telegramOpen: "Open Telegram",
    telegramRetry: "Try again",
    telegramLinkConflict: "This Telegram account is already linked to another account",
    telegramGenericError: "Couldn't sign in with Telegram. Please try again.",
    google: "Sign in with Google",
    telegramOidc: "Sign in with Telegram",
    oauthGenericError: "Couldn't sign in. Try again or use another method.",
    registerToggle: "No account? Sign up",
    loginToggle: "Already have an account? Sign in",
    forgotPassword: "Forgot your password?",
    registerTitle: "Sign up",
    registerSubmit: "Sign up",
    registerSubmitLoading: "Signing up…",
    registerSuccessTitle: "Check your email",
    registerSuccessBody: "We sent a confirmation link to {email}",
    registerErrorGeneric: "Couldn't sign up. Please try again later.",
    emailNotVerifiedError: "Email not confirmed yet — we sent the link again",
    forgotTitle: "Reset password",
    forgotSubtitle: "Enter your email and we'll send a password reset link",
    forgotSubmit: "Send link",
    forgotSubmitLoading: "Sending…",
    forgotSuccessBody: "If {email} has an account with a password, the email is on its way",
    backToLogin: "Back to sign in",
  },

  conflict: {
    title: "Is this you?",
    subtitle: "This sign-in method is already linked to this profile. Sign in to confirm it's you and link the new method.",
    loginWithPassword: "Sign in with email/phone and password",
    cancel: "Cancel",
    success: "Done! The sign-in method is linked.",
    error: "Couldn't link it. Please try again.",
  },

  oauthCallback: {
    processing: "Signing in…",
    linkedTitle: "Done",
    linkedBody: "The sign-in method is linked to your profile",
    errorTitle: "Couldn't sign in",
    errorBody: "Try again or use another sign-in method",
    browserMismatch: "This sign-in link was started in a different browser. Start signing in again from this device.",
    identityAlreadyLinked: "This account is already linked to another EcoWay profile. Sign in with it, or unlink it there first.",
    providerAlreadyLinked: "A sign-in method of this type is already linked to your profile",
    backToMap: "Go to map",
    backToProfile: "Go to profile",
  },

  emailVerify: {
    processing: "Confirming your email…",
    successTitle: "Email confirmed",
    successBody: "Now sign in with your email and password.",
    errorTitle: "Link is invalid",
    errorBody: "The link has expired or was already used. Request a new confirmation email.",
    backToMap: "Go to map",
  },

  resetPassword: {
    title: "New password",
    passwordLabel: "New password",
    submit: "Save password",
    submitLoading: "Saving…",
    successTitle: "Password updated",
    successBody: "You can now sign in with your new password",
    errorTitle: "Link is invalid",
    errorBody: "The link has expired or was already used. Request a new reset link.",
    login: "Sign in",
  },

  hlsPlayer: {
    unavailable: "Stream unavailable",
    stillWatching: "Still watching?",
    continue: "Continue",
  },

  videoControls: {
    play: "Play",
    pause: "Pause",
    mute: "Mute",
    unmute: "Unmute",
    fullscreen: "Fullscreen",
    seek: "Seek",
  },

  live: {
    cameraAlt: "Camera snapshot: {name}",
    playCamera: "Watch live",
    title: "Live",
    nowTitle: "Now",
    nodesCount: "spots",
    eventsCount: "events",
    lastReading: "Last reading:",
    refresh: "Refresh",
    noNodes: "No spots available",
    noEvents: "No published events yet",
    liveBadge: "LIVE",
    privateCamera: "Private camera",
    close: "Close",
    edited: "edited",
    edit: "Edit",
    delete: "Delete",
    postMenu: "Post menu",
    like: "Like",
    composerPlaceholder: "What's new?",
    composerPublish: "Post",
    composerSave: "Save",
    composerCancel: "Cancel",
    addPhoto: "Add photo",
    removePhoto: "Remove photo",
    editPostTitle: "Edit post",
    deleteConfirm: "Delete this post?",
    postFailed: "Failed to save the post",
    pin: "Pin",
    unpin: "Unpin",
    pinned: "Pinned",
    pinFailed: "Failed to change pin state",
    pinLimitReached: "You can pin at most 2 items",
    attachVideo: "Attach video",
    removeVideo: "Remove video",
    selectVideoTitle: "Select a video from storage",
    noAvailableVideos: "No available videos",
    sunrise: "Sunrise",
    sunset: "Sunset",
    sunAt: "{label} at {time}",
    infoTooltip: {
      label: "More info",
      rainPossible: "This is an estimate based on the weather station's readings on the dome (humidity and dew point) - precipitation isn't guaranteed, but is likely.",
      windy: "Sustained wind from 8 m/s - already noticeable on the trail, especially on exposed sections.",
      windStrong: "Sustained wind from 15 m/s - the threshold for a hazardous-phenomenon warning under regional hydromet criteria. Be especially careful on open ridges and summits.",
      windGusty: "Gusts are notably stronger than the average wind - expect sudden jolts, especially on exposed and elevated sections.",
      sunrise: "The time is calculated from the surrounding terrain and reflects when the sun actually crosses the visible horizon. Daylight may start earlier than this time.",
      sunset: "The time is calculated from the surrounding terrain and reflects when the sun actually crosses the visible horizon. It may not get fully dark until later than this time.",
      uvLevels: {
        low: "Low risk for most people - no special protection needed; sunglasses on a bright day are enough.",
        moderate: "Moderate risk - seek shade during midday hours, use SPF 30+ sunscreen, a hat and sunglasses.",
        high: "High risk of sunburn - SPF 30+ sunscreen, a hat and sunglasses are a must; avoid direct sun between 11:00 and 16:00.",
        veryHigh: "Very high risk - unprotected skin can burn in 15-25 minutes. Use SPF 50, cover up as much as possible, seek shade during the day.",
        extreme: "Extreme risk - unprotected skin can burn within minutes. Avoid sun exposure when possible, wear covering clothing and SPF 50+ sunscreen.",
      },
    },
    stationDetail: {
      temp: "Temp",
      feelsLike: "Feels like",
      wind: "Wind",
      windGust: "Gusts",
      humidity: "Humidity",
      dewPoint: "Dew point",
      pressure: "Pressure",
      rainRate: "Rain",
      rainTotal: "Rain (24h)",
      solar: "Solar",
      uv: "UV index",
      nearbyPlaceholder: "Nearby routes are loading from the API",
      compass: { n: "N", ne: "NE", e: "E", se: "SE", s: "S", sw: "SW", w: "W", nw: "NW" },
      uvLevels: {
        low: "Low",
        moderate: "Moderate",
        high: "High",
        veryHigh: "Very high",
        extreme: "Extreme",
      },
      alerts: {
        raining: "Raining now",
        rainPossible: "Precipitation possible",
        windy: "Windy",
        windStrong: "Strong wind",
        windGusty: "Gusty wind",
        feelsLike: "{actual}° (feels like {feels}°)",
      },
      descriptions: {
        temp: "Air temperature at the station.",
        feelsLike: "Perceived temperature accounting for wind chill (cold) or humidity (heat).",
        humidity: "Relative air humidity.",
        dewPoint: "Temperature at which the air becomes saturated with moisture.",
        wind: "Current wind speed and direction.",
        windGust: "Peak wind gust over the last interval.",
        pressure: "Atmospheric pressure.",
        rainRate: "Precipitation intensity right now.",
        rainTotal: "Total precipitation over the last 24 hours.",
        solar: "Solar radiation intensity.",
        uv: "Risk of skin sunburn.",
      },
    },
    detailsTitle: "All readings",
  },

  liveHome: {
    subtitle: "What is happening at the geotent right now: cameras, weather station, timelapses and greetings.",
    title: "Live",
    close: "Close",
    aboutBanner: {
      text: "EcoWay is developed with support from Visit Almaty, Ile-Alatau National Park, and the Almaty Emergency Situations Department",
      button: "About the project",
    },
    timelapseFeed: {
      title: "Timelapses",
      descriptionPlaceholder: "Short description (optional)",
      deleteConfirm: "Remove this timelapse from the carousel?",
      pin: "Pin",
      unpin: "Unpin",
      pinLimitReached: "At most 2 timelapses can be pinned per node",
      pinFailed: "Failed to change pin state",
      download: "Download",
      editDescription: "Edit description",
      saveDescription: "Save",
      saveFailed: "Failed to save changes",
      itemMenu: "Menu",
      delete: "Delete",
    },
  },

  helloFeed: {
    title: "#ПриветEcoway",
    postCount: "{count} greetings from Mynzhylky",
    uploadButton: "Add post",
    play: "Play",
    remove: "Remove",
    captionPlaceholder: "Caption (optional)",
    publish: "Publish",
    download: "Download",
    deleteConfirm: "Delete this post?",
    empty: "No posts yet",
    uploadFailed: "Failed to upload file",
    itemMenu: "Menu",
    editCaption: "Edit caption",
    saveCaption: "Save",
    delete: "Delete",
    saveFailed: "Failed to save changes",
    wave: {
      openButton: "The next one is yours",
      title: "Send your video greeting",
      intro: "Wave, dance, surprise us 🙂 A little later, your video postcard will appear in the #ПриветEcoway feed. Download it and share it with friends.",
      dateLabel: "Date",
      timeLabel: "Time",
      consent: "I consent to the processing and publication of a video featuring me in #ПриветEcoway",
      consentLink: "Video greeting consent",
      submit: "Send",
      cancel: "Cancel",
      successTitle: "Your greeting has been accepted 👋.",
      successMessage: "Keep an eye on the #ПриветEcoway feed — your video postcard will appear there today.",
      close: "Close",
      errorRequired: "Enter the date and time",
      errorConsent: "Consent to publish is required",
      errorFuture: "That time hasn't happened yet",
      errorTooOld: "We review hellos within two weeks",
      errorGeneric: "Couldn't send the request. Please try again later.",
    },
  },

  explore: {
    noRoutes: "No routes",
    onMap: "On the map",
    comingSoon: {
      title: "Smart route matching is coming soon.",
      body: "Tell us where and why you want to go — EcoWay will help you find places and routes that fit your goals, abilities, and mood.",
    },
  },

  feedback: {
    form: {
      title: "Feedback",
      message: "Message",
      messagePlaceholder: "Describe what happened or what could be improved",
      images: "Photos",
      addImage: "Add photo",
      removeImage: "Remove photo",
      imagesHint: "Up to {max} photos, {mb} MB each max",
      tooManyImages: "You can attach up to {max} photos",
      imageTooLarge: "File \"{name}\" is over {mb} MB",
      contactName: "Name",
      contactNamePlaceholder: "Optional",
      contactPhone: "Phone",
      contactEmail: "Email",
      messengerConsent: "I agree to be contacted via {provider}",
      submit: "Send",
      errorGeneric: "Couldn't send your message. Please try again.",
    },
    success: {
      title: "Thank you!",
      message: "We've received your message and will review it.",
    },
  },

  profile: {
    markers: { emptyTitle: "No markers yet", empty: "Drop a point on the map with the Point tool and save it as your own.", onMap: "On map", show: "Show on map", hide: "Hide from map" },
    title: "Profile",
    loginPrompt: "Sign in to your account",
    loginSubtitle: "Track routes and get notifications",
    loginButton: "Sign in",
    editButton: "Edit profile",
    sections: {
      notifications: "Notifications",
      saved: "Saved",
      markers: "My markers",
      trail: "My trail",
      collection: "My routes",
      safety: "Safety",
      settings: "Settings",
    },
    trail: {
      caption: "Your personal progress in the mountains around Almaty",
      distance: "distance",
      gain: "gain",
      routesCount: "routes",
      locationsCount: "locations",
      highestPoint: "highest point",
      lastRouteTileEarned: "latest",
      lastRouteTileEmpty: "empty",
      lastRouteCardLabel: "Latest route",
      emptyNote: "Save a route and complete it — your stats will show up here",
    },
    collection: {
      caption: "Your routes and the ones you saved from the catalog",
      tabs: { mine: "Mine", saved: "Saved" },
      mineEmptyNote: "Draw your first route in the map editor and it will appear here",
      card: {
        public: "Public route, visible to everyone",
        private: "Private route, visible only to you",
        makePublic: "Make public",
        makePrivate: "Make private",
        views: "Views",
        likes: "Likes",
        saves: "Saves",
        share: "Share",
        edit: "Edit",
      shareDisabled: "Make the route public to share it",
      delete: "Delete route",
      deleteConfirmTitle: "Delete route “{name}”?",
      deleteConfirmBody: "The route and its reviews will be removed permanently.",
      deleted: "Route deleted",
      deleteError: "Could not delete the route",
      deleteCancel: "Cancel",
        nowPublic: "The route is now public",
        nowPrivate: "The route is now private",
        visibilityError: "Could not change visibility",
        linkCopied: "Link copied",
      },
      completedEmptyNote: "Completed routes will appear here once you finish a trip",
      savedEmptyNote: "Saved routes will appear here",
    },
    safety: {
      caption: "Register your hikes and share your route plan with family and friends — a simple, basic safety measure before heading out.",
      activeTripLabel: "Active / upcoming trip",
      noActiveTrip: "No registered trips",
      noActiveTripHint: "Register your route before heading out",
      emergencyContact: "Emergency contact",
      emergencyNotSet: "Not set",
      emergencyContactHint: "Prefills the route registration form by default — you can still change it there for a specific trip.",
      emergencyAddButton: "Add",
      emergencyDeleteButton: "Delete",
      emergencyContactSave: "Save",
      emergencyContactCancel: "Cancel",
      emergencyContactSaved: "Emergency contact saved",
      emergencyContactSaveError: "Couldn't save the emergency contact",
      emergencyContactDeleted: "Emergency contact removed",
      emergencyContactDeleteError: "Couldn't remove the emergency contact",
      emergencyDeleteConfirmTitle: "Delete the emergency contact?",
      emergencyDeleteConfirmMessage: "It will no longer be prefilled by default when registering a route.",
      guideTitle: "What to do if…",
      guide: {
        lostTrail: { title: "You lose the trail", body: "Stop, assess visibility, and retrace your steps to the last point you were sure of. Don't continue into fog." },
        badWeather: { title: "Weather turns bad", body: "Descend immediately, stick to valleys, avoid ridges and metal objects during a thunderstorm." },
        noSignal: { title: "There's no signal", body: "Climb higher or move to open ground. Try SMS — it can get through on a weak signal. Conserve your battery." },
        deadPhone: { title: "Your phone dies", body: "Switch to airplane mode, lower brightness to minimum, keep GPS off until you need it. Share your coordinates with your emergency contact in advance." },
        needHelp: { title: "You need help", body: "Call 112. Report your coordinates, condition, and number of people. Stay where you are if it's safe to do so." },
      },
    },
    settings: {
      admin: "Admin panel",
      caption: "Language and account",
      language: "Language",
      privacy: "Privacy",
      privacyOnlyMe: "Only me",
      privacyPublic: "Public",
      help: "Help",
      cookies: "Cookie settings",
      feedback: "Feedback",
      logout: "Log out",
      linkedAccounts: "Linked accounts",
      methodEmail: "Email",
      methodPhone: "Phone",
      methodTelegram: "Telegram",
      methodGoogle: "Google",
      methodVerified: "verified",
      methodUnverified: "unverified",
      addGoogle: "Link Google",
      addTelegram: "Link Telegram",
      linkGenericError: "Couldn't link it. Please try again.",
      unlink: "Unlink",
      unlinkLastMethodError: "Can't unlink your only remaining way to sign in",
    },
    language: "Language",
    about: "About the project",
  },

  editProfile: {
    onboardingTitle: "Complete your profile",
    onboardingSubtitle: "Takes a minute - some fields can be left blank",
    editTitle: "Edit profile",
    avatarChange: "Change avatar",
    avatarRemove: "Remove avatar",
    avatarError: "Couldn't update the avatar",
    avatarLoadingFromProvider: "Loading avatar from Telegram…",
    cropTitle: "Crop avatar",
    cropApply: "Apply",
    cropHint: "Drag the frame or its corners to resize the area",
    username: "Username",
    usernameRequired: "Username is required",
    usernameFormat: "3-30 characters: lowercase letters, digits, _",
    usernameReserved: "This username is reserved",
    usernameTaken: "This username is already taken",
    firstName: "First name",
    lastName: "Last name",
    gender: "Gender",
    genderUnset: "Not set",
    genderMale: "Male",
    genderFemale: "Female",
    genderOther: "Other",
    birthDate: "Date of birth",
    visibility: "Public profile",
    visibilityHint: "Controls what strangers see at your profile link",
    visibilityPrivate: "Private",
    visibilityPublic: "Public",
    submitOnboarding: "Continue",
    submitEdit: "Save",
    saveError: "Couldn't save the profile",
    consentText: "I accept the Terms of Service and consent to the collection and processing of personal data in accordance with the Privacy Policy.",
  },

  publicProfile: {
    routesTitle: "Routes by this author",
    routesEmpty: "No public routes yet",
    notFoundTitle: "Profile not found",
    notFoundSubtitle: "This user doesn't exist, or the link is outdated",
    private: "This profile is private",
  },

  hikeCard: {
    notFoundTitle: "Hike not found",
    notFoundSubtitle: "This registration doesn't exist, or the link is outdated",
    dates: "Dates",
    participants: "Participants",
    track: "Track",
    emergencyContact: "Emergency contact",
    footnote: "This hike's info was shared as part of the EcoWay / Almaty Emergency Situations Department pilot. It is not an official registration with the emergency services.",
    openOnMap: "Open the route on the map",
    status: {
      active: "In progress",
      returned: "Completed",
      cancelled: "Cancelled",
    },
  },

  routeRegistration: {
    banner: {
      soon: "Your registration expires soon: {minutes} min left",
      overdue: "Your return time has passed",
      extend: "Extend by 1 hour",
      returned: "I'm back",
      hide: "Hide",
      error: "Something went wrong. Please try again.",
    },
    profile: {
      extendButton: "+1 h",
      title: "Route registration",
      registerButton: "Register for a route",
      expectedReturn: "Expected return",
      cancelButton: "Cancel",
      returnButton: "I'm back",
      cancelConfirmTitle: "Cancel this trip?",
      cancelConfirmMessage: "The registration will be cancelled. This can't be undone.",
      cancelConfirmButton: "Yes, cancel",
      returnConfirmTitle: "Mark as returned?",
      returnConfirmMessage: "The registration will be closed as completed.",
      returnConfirmButton: "Yes, I'm back",
      keepButton: "Not now",
      editButton: "Edit",
      shareButton: "Share",
      changesSaved: "Changes saved",
      shareText: "I've headed out on a hike and registered it with the Emergency Situations Department.",
      shareCopied: "Link copied",
      shareCopyError: "Couldn't copy the link",
    },
    form: {
      title: "Route registration",
      whyRegister: "Register your trips — it's a simple, basic safety measure before you head out.",
      editTitle: "Edit registration",
      saveChanges: "Save",
      steps: { route: "Route", dates: "Dates", contacts: "Contacts", confirm: "Confirm" },
      stepCounter: "Step {n} of {total}",
      changeRoute: "Change",
      back: "Back",
      cancel: "Cancel",
      next: "Next",
      contactPhone: "My phone",
      emergencyContactPhone: "Emergency contact — phone",
      emergencyContactHint: "Phone number of someone staying reachable in the city",
      invalidPhone: "Enter a number in the format +7XXXXXXXXXX",
      route: "Route",
      routeListLabel: "Route list",
      routeTabSaved: "Saved",
      routeTabMine: "Mine",
      routeTabAll: "All",
      noSavedRoutes: "Nothing saved yet. Save a route in the catalog or use search.",
      noOwnRoutes: "You have no routes of your own yet.",
      routeModeDirectory: "From directory",
      routeModeManual: "Describe manually",
      routeModeTrack: "Upload a track",
      noRoutesFound: "No routes found",
      routeDescriptionPlaceholder: "Describe the route in your own words",
      trackUploadPrompt: "Upload a GPX file",
      trackExistingFile: "Uploaded track",
      trackApproxDistance: "≈ {km} km along the track",
      trackInvalidFile: "A .gpx file is required",
      trackTooLarge: "File is larger than {mb} MB",
      trackParseError: "Couldn't read the track — check the file",
      participants: "Participants",
      participantsPlaceholder: "List the trip's participants",
      startDate: "Start date",
      expectedReturn: "Expected return date/time",
      quickHint: "The return time is filled in from the route's estimated time, with a margin. Check it and confirm.",
      editDetails: "Edit details",
      consentCombined: "I accept the route registration terms and consent to the processing and transfer of the provided data to the Almaty Emergency Situations Department.",
      consentServiceRulesLink: "Safety Service Rules",
      consentDchsDataLink: "Data processing and transfer consent",
      submit: "Register",
      errorAlreadyActive: "You already have an active registration — finish that one first.",
      errorGeneric: "Couldn't submit the registration. Please try again.",
    },
    terms: {
      close: "Got it",
    },
    success: {
      title: "Route registered",
      message: "Your route info is saved in EcoWay and, as part of the pilot, available to the Almaty Emergency Situations Department. Share the plan with family or friends so they know where you're headed and when you plan to be back.",
    },
  },

  aboutProject: {
    backButton: "Back",
    navTitle: "About the project",
    hero: { tagline: "A living map of natural trails" },
    section1: {
      title: "A map we build together",
      body1: "No map can stay accurate on its own. Trails change. Water appears and disappears. Fords get harder to cross. A section washes out somewhere, and somewhere else a good rest stop appears.",
      body2: "That's why EcoWay grows together with the people who actually walk these trails. Noticed something important — add an observation. Water, trail condition, a ford, a campsite, litter, or any other change — every note makes the shared map more useful for whoever comes next.",
      cta: "Add an observation",
    },
    section2: {
      title: "See more before you set out",
      body1: "Some of EcoWay's information comes straight from the terrain. Live cameras help you see the real conditions, and data from the stations helps you understand the weather on site.",
      body2: "We want it to be possible, before setting out, not just to check a forecast or a route description, but to actually see what's happening out there.",
      cta: "Watch Live",
    },
    section3: {
      title: "Leave word about your trip",
      body1: "Safety starts with simple habits. Register your trips and share your route plan with people close to you — so that information about where you went and when you plan to return stays available.",
      body2: "EcoWay's route registration service is developing in pilot mode together with Almaty's Emergency Situations Department.",
      cta: "Safety",
    },
    section4: {
      title: "EcoWay is just getting started",
      body1: "We're gradually adding new routes, observation points, and data from natural areas.",
      body2: "Our goal is for EcoWay to become, over time, a place where before setting out you can choose a route, understand the real conditions, prepare for them, and leave word about your trip.",
      body3: "The more people share what they see on the trails, the more accurate this picture becomes.",
      closing: "Building a living map together.",
    },
    sponsors: {
      title: "Supported by",
      park: "Ile-Alatau National Park",
      mes: "Almaty Emergency Situations Department",
    },
    cta: {
      title: "Have something to add?",
      body: "Found an inaccuracy, know a route, or have an idea for EcoWay — tell us about it.",
      button: "Message us",
    },
    brandLine: "Be confident on your path",
    contactsTitle: "Contacts",
    documents: {
      title: "Documents",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      dataConsent: "Consent to data collection and processing",
      serviceRules: "Safety Service Rules",
      routeDataConsent: "Consent to transfer data to Almaty ESD",
      videoGreetingConsent: "Consent to the creation and publication of an EcoWay video greeting (pilot period)",
    },
  },

  legalDocuments: {
    languageLabel: "Document language",
  },

  camera: {
    live: "LIVE",
    watchStream: "Watch stream →",
  },

  map: {
    tools: { button: "Tools" },
    contextLost: {
      message: "The map is temporarily unavailable on this device.",
      retry: "Retry",
    },
    layers: {
      base: "Base map",
      nodes: "Nodes (cameras & stations)",
      routes: "Routes",
      pois: "Route points",
    },
    locateMe: "My location",
    locateMeApproximate: "My location (approximate, by IP)",
    northUp: "Face north",
    compassMode: "Follow compass",
    toggle3d: "Show terrain (3D)",
    toggle2d: "Hide terrain (2D)",
    layersControl: {
      button: "Map layers",
      base: "Map",
      topo: "Topo",
      topo3d: "3D topo",
      poi: "Icon layers",
      poiGroup: {
        stayWater: "Camps & water",
        obstacles: "Obstacles",
        rest: "Rest",
        viewpoint: "Viewpoints",
        amenities: "Amenities",
      },
      poiGroupInfo: {
        stayWater: "Campsites, alpine and wilderness huts, springs, wells, water points, drinking water, waterfalls.",
        obstacles: "Fords across rivers and streams.",
        rest: "Shelters, fire pits, picnic tables.",
        viewpoint: "Viewpoints.",
        amenities: "Toilets, waste bins and containers.",
      },
      overlays: "Overlays",
      protectedAreas: "National parks & reserves",
      routeCoverage: "Trail coverage by routes",
      coveragePopupTitle: "Routes here",
      coverageOpen: "Open",
    },
    attribution: {
      title: "Map data",
      button: "About map data sources",
      close: "Close",
      licence: "OpenStreetMap data is available under the ODbL licence.",
    },
    pointTool: {
      button: "Drop a point",
      title: "Point",
      close: "Close",
      copy: "Copy coordinates",
      copied: "Copied",
      ownMarker: "Own marker",
      rename: "Rename",
      routesHere: "Routes here",
      startHere: "Start here",
      share: "Share",
      delete: "Delete",
      loginRequired: "Sign in to save markers",
      namePlaceholder: "Marker name",
      kindLabel: "Marker type",
      saveMarker: "Save",
      cancel: "Cancel",
      draftExists: "The editor already has a draft - clear it to start from here",
      failed: "Could not save the marker",
      kind: {
        custom: "Custom",
        camp: "Camp",
        water: "Water",
        viewpoint: "Viewpoint",
        danger: "Hazard",
        parking: "Parking",
        other: "Other",
      },
    },
    editMode: "Edit map",
    debugPanel: "Map debug",
    editSaved: "Changes saved",
    editReverted: "Edit removed, reverted to original data",
    editSaveError: "Failed to save changes",
    ruler: {
      button: "Ruler",
      title: "Ruler",
      close: "Close ruler",
      hint: "Click the map to drop points. Right-click or long-press the line to add or remove a point.",
      details: "Line details",
      total: "Total",
      gain: "Gain",
      loss: "Loss",
      noElevation: "Elevation is unavailable outside the terrain coverage area.",
      partialElevation: "Part of the line is outside terrain coverage — totals cover the measurable sections only.",
      clear: "Clear",
      vertexAria: "Ruler point",
      menuAddPoint: "Add point here",
      menuDeletePoint: "Delete this point",
      menuStraightenLeg: "Straighten this segment",
      menuMagnetizeLeg: "Snap this segment",
      magnet: "Magnet: follow roads and trails",
      undo: "Undo last action",
      redo: "Redo last undone action",
      routingFallback: "No network route was found — a straight line was used.",
      routeBlocked: "Can't route there: a river or cliff is in the way — the point was not added.",
    },
    routeEditor: {
      button: "Route editor",
      title: "Route editor",
      close: "Close editor",
      authRequired: "Sign in to draw and save your own routes.",
      modeLine: "Line",
      modeWaypoint: "Waypoints",
      hintLine: "Click the map to draw a route.",
      hintWaypoint: "Click the map to drop a waypoint of the selected type.",
      magnet: "Magnet: follow roads and trails",
      magnetShort: "Magnet",
      snapWaypointToLine: "Snap waypoint to the route line",
      undo: "Undo last action",
      redo: "Redo last undone action",
      clear: "Clear all",
      total: "Total",
      gain: "Gain",
      loss: "Loss",
      duration: "Estimated time",
      noElevation: "Elevation is unavailable outside the terrain coverage area.",
      segments: "Days and segments",
      waypointType: "Waypoint type",
      waypointName: "Name",
      waypointDescription: "Description",
      deleteWaypoint: "Delete waypoint",
      deleteLastPoint: "Delete last line point",
      openMine: "My routes",
      newRoute: "New route",
      save: "Save",
      saveAs: "Save as…",
      exportGpx: "Export to GPX",
      cancelConfirm: "Discard editing? Unsaved changes will be lost.",
      unsavedTitle: "Leave the editor?",
      routeBlocked: "Can't route there: a river or cliff is in the way",
      labelUndo: "Undo",
      labelRedo: "Redo",
      labelReverse: "Reverse",
      labelCloseLoop: "Close loop",
      labelLegStraight: "Straight",
      labelLegRouted: "Along trails",
      labelSnapPoint: "Snap to line",
      labelInfo: "Hints",
      closeShort: "Close",
      actionsLabel: "Route actions",
      toolsLabel: "Editor tools",
      downloadGpx: "Download GPX",
      importLabel: "Import",
      importFromGpx: "From GPX",
      importFromCatalogue: "From catalogue",
      importFromMine: "From mine",
      labelNew: "New",
      hintNew: "New route",
      hintUndo: "Undo the last action",
      hintRedo: "Redo the undone action",
      hintReverse: "Reverse the route: start and finish swap places",
      hintCloseLoop: "Close the loop: add a leg from the finish back to the start",
      hintLegStraight: "Leg {km} km: straight. Tap to route it along trails",
      hintLegRouted: "Leg {km} km: along trails. Tap to make it straight",
      hintSnapPoint: "Snap the selected point to the line or a trail",
      hintInfo: "Hints: what each button does",
      onboardingTitle: "Route editor",
      onboardingIntro: "A quick tour. Button hints are always available in the bottom bar: Actions → Hints.",
      dontShowAgain: "Do not show again",
      gotIt: "Got it",
      onboarding: {
        line: { title: "Line", text: "Press the button and tap the map to draw the route." },
        point: { title: "Point", text: "An overnight stop splits the route into days, a rest stop splits a day into sections." },
        erase: { title: "Eraser", text: "Tap a line vertex or a point to delete it." },
        magnet: { title: "Magnet", text: "Line legs are routed along trails and roads, and points snap to the line and trails." },
        edit: { title: "Editing", text: "Drag vertices and points, tap a point to edit it, or tap the line to select a leg." },
      },
      toolLine: "Line",
      toolPoint: "Point",
      toolErase: "Eraser",
      closeWaypoint: "Close without saving",
      reverse: "Reverse route (swap start and finish)",
      startLabel: "Start",
      finishLabel: "Finish",
      startFinishLabel: "Start/finish",
      discard: "Discard",
      keepEditing: "Continue",
      clearConfirm: "Clear everything drawn? This cannot be undone.",
      loadError: "Failed to load the route for editing.",
      saveError: "Failed to save the route.",
      needTwoPoints: "Draw a route of at least two points before saving.",
      unsavedIndicator: "Unsaved changes",
      menuFile: "File",
      menuNew: "New",
      menuImport: "Import",
      menuActions: "Actions",
      menuView: "View",
      viewStatsPanel: "Statistics",
      viewLineStyle: "Line style",
      viewLineSolid: "Solid",
      viewLineGradient: "Gradient",
      viewDirectionArrows: "Direction arrows",
      view3d: "3D view",
      tabProfile: "Profile",
      tabStats: "Statistics",
      namePlaceholder: "Name your route",
      profileTitle: "Elevation profile",
      sectionsTitle: "Sections",
      addWaypointDialog: {
        typeMarker: "Marker",
        markerHint: "A personal note on the map - visible only to you, under My markers. Not part of the route.",
        title: "New waypoint",
        confirm: "Add",
      },
      importDialog: {
        title: "Import route",
        close: "Close",
        tabMine: "Mine",
        tabFavorites: "Favorites",
        tabPublic: "Public",
        tabGpx: "GPX file",
        emptyMine: "You don't have any routes yet",
        emptyFavorites: "Your favorites list is empty",
        emptyPublic: "No routes found",
        uploadButton: "Choose GPX file…",
        uploadHint: "A file in GPX format (.gpx)",
        importError: "Failed to read the GPX file",
      },
      saveDialog: {
        titleNew: "Save route",
        titleExisting: "Save changes",
        name: "Name",
        namePlaceholder: "e.g. \"Kok-Zhailyau via the plateau\"",
        description: "Description",
        descriptionPlaceholder: "A short note about the route — optional",
        tags: "Tags",
        tagsPlaceholder: "comma-separated",
        visibility: "Visibility",
        visibilityHint: "Public — visible to everyone in the catalog, private — only to you",
        public: "Public",
        private: "Private",
        cancel: "Cancel",
        confirm: "Save",
        nameRequired: "Enter a route name",
      },
    },
  },

  captive: {
    welcomeTitle: "Welcome",
    welcomeSubtitle: "Tap Connect to get online",
    connectButton: "Connect",
    defaultNodeName: "Mynzhylky",
    metersShort: "m",
    windUnit: "m/s",
    precipUnit: "mm",
    wave: {
      heading: "Send a greeting from the summit",
      body: "The camera will catch your moment — we'll turn it into a video postcard.",
      step1: "Wave",
      step2: "Note the time",
      step3: "Submit request",
      cta: "Get your postcard",
    },
    amenities: {
      title: "Geo-tent \"Kusto Heights\"",
      body: "Rest, charge your phone, and get in touch.",
    },
    visitors: {
      per30days: "visitors in the last 30 days",
      today: "Today",
    },
    routesLinkTitle: "Nearby routes map",
    satelliteNote: "Internet runs over a satellite link. Please use it sparingly.",
  },

  tgRegister: {
    title: "Register a hike",
    openInTelegram: "Open the form from the bot",
    openInTelegramHint: "This page only works inside Telegram: tap \"Register a route\" in the EcoWay bot.",
    loading: "Loading…",
    authError: "Couldn't sign in via Telegram. Close the form and open it from the bot again.",
    retry: "Retry",
    close: "Close",
    active: {
      title: "You have an active registration",
      extendHour: "Extend by an hour",
      extended: "Return time extended",
      actionError: "Something went wrong. Please try again.",
    },
    returned: {
      title: "Welcome back!",
      message: "The registration is closed. Glad you're safe.",
      newRegistration: "New registration",
    },
    success: {
      reminders: "The bot will remind you about your return time — you can extend it or check in right there.",
    },
  },
};
